<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal w-1/2"
        role="dialog"
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <header id="modal-title" class="modal-header">
          <slot name="header">
            <strong>{{ name }}</strong>
          </slot>
        </header>

        <section id="modal-description" class="modal-body">
          <slot name="body">
            <div class="flex flex-wrap">
              <div class="w-full lg:w-1/4 text-center">
                <span>Ordem [{{ order + 1 }}]</span>

                <span class="flex mt-3">
                  <span class="ml-auto mr-3" @click="asc()">
                    <icon name="chevron-up" class="w-6 h-6" :class="getAscendStyle()" />
                  </span>

                  <span class="ml-3 mr-auto" @click="desc()">
                    <icon name="chevron-down" class="w-6 h-6" :class="getDescendStyle()" />
                  </span>
                </span>
              </div>

              <div class="w-full lg:w-1/4 text-center">
                <label for="category" class="form-label">Categoria</label>

                <select
                  id="category"
                  class="form-select"
                >
                  <option :value="null">Nenhuma</option>
                  <option
                    v-for="selectCategory in categories"
                    :key="selectCategory.id"
                    :value="selectCategory.id"
                    :selected="selectCategory.id == category"
                  >
                    {{ selectCategory.label }}
                  </option>
                </select>
              </div>

              <div class="w-full lg:w-1/4 text-center">
                <label for="fieldset" class="form-label">Grupo</label>

                <select
                  id="fieldset"
                  class="form-select"
                >
                  <option :value="null">Nenhum</option>
                  <option
                    v-for="selectFieldset in fieldsets"
                    :key="selectFieldset.id"
                    :value="selectFieldset.id"
                    :selected="selectFieldset.id == fieldset"
                  >
                    {{ selectFieldset.label }}
                  </option>
                </select>
              </div>

              <div class="w-full lg:w-1/4 text-center">
                <span>Habilitado</span>

                <span class="flex mt-3">
                  <label class="form-label ml-auto mr-3">
                    <input id="undisabled" type="radio" name="disabled" value="false" :checked="!disabled" />
                    Sim
                  </label>

                  <label class="form-label ml-3 mr-auto">
                    <input id="disabled" type="radio" name="disabled" value="true" :checked="disabled" />
                    Não
                  </label>
                </span>
              </div>
            </div>
          </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            <section class="flex flex-wrap">
              <button class="btn-gray ml-auto mr-3" type="button" @click="cancel">
                Cancelar
              </button>
              <button class="btn-indigo ml-3 mr-0" type="button" @click="save">
                Salvar
              </button>
            </section>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
  },
  props: {
    indicator: Number,
    name:      String,
    category:  Number,
    fieldset:  Number,
    order:     Number,
    disabled:  Boolean,

    categories: Array,
    fieldsets:  Array,

    min: Number,
    max: Number,
  },
  data() {
    return {
      toAsc: false,
      toDesc: false,
    }
  },
  updated() {
    document.getElementById('category').value = this.category ?? ''
    document.getElementById('fieldset').value = this.fieldset ?? ''
    document.getElementById(`${!this.disabled ? 'un' : ''}disabled`).checked = true
  },
  methods: {
    save() {
      let category = Number(document.getElementById('category').value)

      if(!category)
      {
        category = null
      }

      let fieldset = Number(document.getElementById('fieldset').value)

      if(!fieldset)
      {
        fieldset = null
      }

      this.$inertia.form({
        id: this.indicator,
        order: this.order,
        toAsc: this.toAsc,
        toDesc: this.toDesc,
        category: category,
        fieldset: fieldset,
        disabled: document.getElementById('disabled').checked,
      }).post(this.route('indicators.configure'), {
        onSuccess: () => window.location.reload(),
      })
    },
    cancel() {
      this.toAsc = false
      this.toDesc = false

      this.$emit('close')
    },
    asc() {
      if(!this.canAscend())
      {
        return
      }

      this.toAsc = !this.toAsc
      this.toDesc = false
    },
    desc() {
      if(!this.canDescend())
      {
        return
      }

      this.toDesc = !this.toDesc
      this.toAsc = false
    },
    canAscend() {
      return this.order > this.min
    },
    canDescend() {
      return this.order < this.max
    },
    getAscendStyle() {
      const canAscend = this.canAscend()

      return {
        'cursor-pointer': canAscend,
        'fill-green-300': canAscend && this.toAsc,
        'fill-gray-600': canAscend && !this.toAsc,
        'fill-gray-300': !canAscend,
      }
    },
    getDescendStyle() {
      const canDescend = this.canDescend()

      return {
        'cursor-pointer': canDescend,
        'fill-green-300': canDescend && this.toDesc,
        'fill-gray-600': canDescend && !this.toDesc,
        'fill-gray-300': !canDescend,
      }
    },
  },
}
</script>
